import { UserPermissions, UserSubscription } from '@creditsights/api-ui-web';
import { DealMarketStatus } from '../../models/CompanyDeal';

const TABS_CONFIG: Record<UserSubscription, DealMarketStatus[]> = {
  [UserSubscription.CS_CR_LFI]: [DealMarketStatus.All, DealMarketStatus.InMarket, DealMarketStatus.Expected, DealMarketStatus.Completed, DealMarketStatus.Hung],
  [UserSubscription.CS_CR]: [DealMarketStatus.All, DealMarketStatus.InMarket, DealMarketStatus.Completed, DealMarketStatus.Hung],
  [UserSubscription.CS_LFI]: [DealMarketStatus.All, DealMarketStatus.InMarket, DealMarketStatus.Expected, DealMarketStatus.Completed, DealMarketStatus.Hung],
  [UserSubscription.CR_LFI]: [DealMarketStatus.All, DealMarketStatus.InMarket, DealMarketStatus.Expected, DealMarketStatus.Completed, DealMarketStatus.Hung],
  [UserSubscription.CS]: [DealMarketStatus.All, DealMarketStatus.InMarket, DealMarketStatus.Completed, DealMarketStatus.Hung],
  [UserSubscription.CR]: [DealMarketStatus.All, DealMarketStatus.InMarket, DealMarketStatus.Completed, DealMarketStatus.Hung],
  [UserSubscription.LFI]: [DealMarketStatus.All, DealMarketStatus.InMarket, DealMarketStatus.Expected, DealMarketStatus.Completed, DealMarketStatus.Hung],
  [UserSubscription.RP]: [],
};

// used also by @creditsights/creditsights-web MFE
export const getDealsTabs = ({ userSubscription }: UserPermissions): DealMarketStatus[] => {
  return TABS_CONFIG[userSubscription];
};
